import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Modal from '@helsenorge/designsystem-react/components/Modal';
import Spacer from '@helsenorge/designsystem-react/components/Spacer';
import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import SafeHTML from '@helsenorge/framework-utils/components/safe-html';
import CookieForm from './cookie-form';
import { useResources, getResources, ResourceContextProvider } from './resources';
const CookieBanner = (props) => {
    const resources = useResources();
    return (_jsxs(Modal, { title: resources.cookie_consent_modal_title, noCloseButton: true, children: [_jsx(Spacer, {}), _jsx(SafeHTML, { html: resources.cookie_consent_introduction }), _jsx(Spacer, {}), _jsx(CookieForm, { onSave: props.onSave })] }));
};
const CookieBannerWrapper = (props) => {
    const resources = getResources(props.language || LanguageLocales.NORWEGIAN);
    return (_jsx(ResourceContextProvider, { value: resources, children: _jsx(CookieBanner, { onSave: props.onSave }) }));
};
export default CookieBannerWrapper;
